import React from 'react';
import _ from 'lodash';
import styles from './outdoorCreativeDetail.module.scss';
import {
  CreativeListRecord,
  isImageAudioFamily,
  OutdoorType
} from 'core/creative/Creative';
import { ImagePreview } from 'components/common/Image/ImagePreview';
import { VideoPreview } from 'components/common/Video/VideoPreview';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArchive } from '@fortawesome/free-regular-svg-icons';
import videoPlaceholder from 'assets/video-placeholder.svg';
import i18n from 'i18n';

export const OutdoorCreativeDetail: React.FunctionComponent<{
  creative: Partial<CreativeListRecord>;
}> = (props) => {
  const creativeValue = _.get(
    props.creative,
    'creativeValue',
    _.get(props.creative, 'creativeValues')
  );
  if (!creativeValue) {
    return <div />;
  }

  const outdoorType = _.get(props.creative, 'outdoorType', OutdoorType.VIDEO);
  const videoUrl = _.get(creativeValue, 'videoUrl', '') as string;
  const imageUrl = _.get(creativeValue, 'imageUrl', '') as string;
  const showVideo = [OutdoorType.VIDEO, OutdoorType.VIDEO_IMAGE].includes(
    outdoorType
  );

  const renderVideo = (source?: string) => {
    if (!source) {
      return (
        <div className={styles.videoPlaceholder}>
          <img src={videoPlaceholder} alt={'preview area'} />
          <span>{i18n.t('videoCreativeDetail.labels.generating')}</span>
        </div>
      );
    }
    return (
      <VideoPreview
        maxWidth={outdoorType === OutdoorType.VIDEO_IMAGE ? 189 : undefined}
        maxHeight={337}
        src={source}
      />
    );
  };

  return (
    <div className={styles.outdoorCreativeDetailContainer}>
      <div className={styles.outdoorCreativeDetail}>
        {showVideo && renderVideo(videoUrl)}
        {(outdoorType === OutdoorType.VIDEO_IMAGE ||
          isImageAudioFamily(outdoorType)) && (
          <ImagePreview
            maxWidth={outdoorType === OutdoorType.VIDEO_IMAGE ? 189 : 600}
            maxHeight={
              outdoorType === OutdoorType.VIDEO_IMAGE ? undefined : 337
            }
            border={false}
            url={imageUrl}
            config={{
              showName: false,
              showSize: false
            }}
          />
        )}
        {outdoorType === OutdoorType.HTML5 && (
          <div className={styles.h5Preview}>
            <FontAwesomeIcon icon={faFileArchive} />
          </div>
        )}
      </div>
    </div>
  );
};
